import React, { useEffect } from "react";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import moment from "moment";
import { useModalAlert } from "../GeneralComponents";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start", // Vertical centering
    whiteSpace: "pre-wrap", // Tries to keep the text on a single line
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function DocumentaryTypes() {
  const classes = useStyles();
  const [typeDocumental, setTypeDocumental] = React.useState(null);
  const [listTypesDocumentales, setListTypesDocumentales] = React.useState([]);
  const { showModalAlert } = useModalAlert();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);

  useEffect(() => {
    loadTipoDocumentales();
  }, [page, pageSize]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const columns = [
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descripcion",
      headerName: "NOMBRE DEL TIPO DOCUMENTAL",
      type: "string",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "tiempo_tramite",
      headerName: "TIEMPO DE TRÁMITE (DÍAS)",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "codigo", label: "Código", type: "text" },
    { name: "descripcion", label: "Nombre del tipo documental", type: "text" },
    {
      name: "tiempo_tramite",
      label: "Tiempo de Trámite (Días)",
      type: "text",
    },
  ];

  const requiredFields = ["codigo", "descripcion", "tiempo_tramite"];

  const onActivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_tipo_documental: row.id_gd_tipo_documental,
        id_usuario: usuario.id_usuario,
      };
      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "tipo-documental/activar",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        }
      );
      loadTipoDocumentales();
      showModalAlert("success", "Se activo correctamente el tipo documental");
    } catch (error) {
      showModalAlert("danger", "Error al activar el tipo documental");
    }
  };
  const onInactivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_tipo_documental: row.id_gd_tipo_documental,
        id_usuario: usuario.id_usuario,
      };
      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "tipo-documental/inactivar",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        }
      );
      loadTipoDocumentales();
      showModalAlert("success", "Se inactivo correctamente el tipo documental");
    } catch (error) {
      showModalAlert("danger", "Error al inactivar el tipo documental");
    }
  };

  const loadTipoDocumentales = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `tipo-documental/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setListTypesDocumentales(data.results);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  async function handleSaveNewSerie(formData) {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    let datos = {
      ...formData,
      id_usuario: usuario.id_usuario,
    };
    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "tipo-documental/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        }
      );
      const result = await updateResponse.json();
      loadTipoDocumentales();
      showModalAlert("success", "Se creo correctamente el tipo documental");
    } catch (error) {
      showModalAlert("danger", "Error al crear el tipo documental");
    }
  }

  return (
    <>
      <GeneralTable
        title="Tipos Documentales"
        titleAlert="Tipo Documental"
        buttonText="Crear Tipo documental"
        columns={columns}
        rows={listTypesDocumentales}
        modalFields={newModalField}
        initialFormData={{
          codigo: "",
          descripcion: "",
          fecha_creacion: moment(),
        }} // Valores iniciales del formulario
        onSaveModal={handleSaveNewSerie}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableActivate
        //onUpdate={onUpdate}
        enableUpdate={false}
        enableDocumentarytype={false}
        enableView={false}
        requiredFields={requiredFields}
        loadList={loadTipoDocumentales}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
    </>
  );
}
